import { render, staticRenderFns } from "./SlideNumber.vue?vue&type=template&id=05eb9892&"
import script from "./SlideNumber.vue?vue&type=script&lang=js&"
export * from "./SlideNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports